export enum IssuerType {
  DID = 'DID',
  ROLE = 'ROLE',
}
